var React = require('react');

function IcStarFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 25.6167L27.3 31.8334L24.5667 20.1167L33.6667 12.2334L21.6834 11.2167L17 0.166687L12.3167 11.2167L0.333374 12.2334L9.43337 20.1167L6.70004 31.8334L17 25.6167Z","fill":"#181919"}));
}

IcStarFilled.defaultProps = {"width":"34","height":"32","viewBox":"0 0 34 32","fill":"none"};

module.exports = IcStarFilled;

IcStarFilled.default = IcStarFilled;
